// extracted by css-extract-rspack-plugin
export default {"container":"VoBF7","label":"agdK9"};